import React from 'react';
import { Button } from '@/components/ui/button';
import { ChevronLeft, RotateCcw, Loader2 } from 'lucide-react';

interface WizardNavigationProps {
  onBack?: () => void;
  onReset?: () => void;
  onSubmit?: () => void;
  disabled?: boolean;
  isLoading?: boolean;
}

const WizardNavigation: React.FC<WizardNavigationProps> = ({
  onBack,
  onReset,
  onSubmit,
  disabled = false,
  isLoading = false,
}) => {
  return (
    <div className="flex justify-between items-center">
      <div className="flex items-center space-x-4">
        {onBack && (
          <Button
            onClick={onBack}
            variant="outline"
            className="flex items-center space-x-2 !bg-transparent hover:!bg-transparent border-gray-300"
          >
            <ChevronLeft size={16} />
            <span>Back</span>
          </Button>
        )}
        {onReset && (
          <Button
            onClick={onReset}
            variant="ghost"
            className="flex items-center space-x-2 hover:bg-transparent text-gray-700 hover:text-gray-900"
          >
            <RotateCcw size={16} />
            <span>Reset</span>
          </Button>
        )}
      </div>

      <div className="flex items-center space-x-6">
        {onSubmit && (
          <Button
            onClick={onSubmit}
            disabled={disabled || isLoading}
            className="bg-primary-500 hover:bg-primary-600 text-white px-6 py-2 flex items-center space-x-2"
          >
            {isLoading ? (
              <>
                <Loader2 size={16} className="animate-spin" />
                <span>Loading...</span>
              </>
            ) : (
              <span>Continue</span>
            )}
          </Button>
        )}
      </div>
    </div>
  );
};

export default WizardNavigation;
